import {Dialog}from '@mui/material';
import { CircleNumberMissingAnswers, WrapperMissingAnswers, PopupTitle, WrapperActions, ButtonStyled, BackIconStyled, SendIconStyled, DescriptionStyled, DialogContentStyled } from './MissingAnswersPopup.styled';

export const MissingAnswersPopup = ({isOpenMissingPopup ,onSubmit, onCloseMissingPopup, missingAnswerList}) => {


    return (
        <Dialog
            open={isOpenMissingPopup} 
            onClose={onCloseMissingPopup}
        >
            <PopupTitle>
               Risposte mancanti
            </PopupTitle>

            <DialogContentStyled>

                {missingAnswerList &&
                    <DescriptionStyled>Non hai risposto
                        <span>
                            {missingAnswerList.length > 1 ? ' alle domande:' : ' alla domanda:'}
                        </span>
                    </DescriptionStyled>}
                   
                <WrapperMissingAnswers>
                {missingAnswerList && missingAnswerList.map(number =>
                    <CircleNumberMissingAnswers key={number}>{number}</CircleNumberMissingAnswers>)}
                </WrapperMissingAnswers>

            </DialogContentStyled>

            <WrapperActions >

                <ButtonStyled onClick={onCloseMissingPopup} variant='contained' color="benjamin">
                    <BackIconStyled/>
                    indietro
                </ButtonStyled>
                <ButtonStyled onClick={onSubmit} variant='outlined' color="benjamin">
                    <SendIconStyled/>
                    invia
                </ButtonStyled>                
              
            </WrapperActions>
        </Dialog>
    );
};